@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled" [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition)}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span [matTooltipPosition]="'below'"
            [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
            <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
          </span>
        }
      </div>
      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)" tabindex="0"
             [ngClass]="{'read-value':accessManager.hasAllNeededPermissions(permissionsForEdition) &&  preconditionsForEdition, 'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}">
          <div class="label-container">
            <div [ngClass]="[cssClass + '-' + getFieldValue()?.toLowerCase()]"
              class="label-content dpe-label-content not-hoverable">
              {{ getFieldValue() | emptyFieldPipe: {blankFieldValue: appConfig.EMPTY_FIELD_VALUE} }}
            </div>
          </div>
          @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
            <span class="overlay-icon">
              @if (preconditionsForEdition) {
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil" class="selectable"></mat-icon>
              } @else {
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil-off" [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate" class="tooltip-icon"></mat-icon>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled" class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span [matTooltipPosition]="'below'"
                  [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
              <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
            </span>
          }
        </div>
      }
      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <div class="dpe-block fx-layout-row fx-justify-space-evenly fx-align-center">
          @for (value of dpeList; track value) {
            <div class="label-container">
              <div (click)="selectDpeValue(value)"
                [ngClass]="[cssClass + '-' + value?.toLowerCase(), isLabelSelected(value)]"
                class="label-content dpe-label-content">{{ value }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
